'use strict';

const get = require('lodash.get');
const React = require('react');
const PropTypes = require('prop-types');
const { Component } = React;
const Relay = require('react-relay/classic');

// Stores
const ItemStore = require('../../stores/ItemStore.es');
const PdpUiStore = require('../../stores/PdpUiStore.es');
const UserStore = require('../../../global/stores/UserStore.es');

// Actions
const PdpActions = require('../../actions/PdpActions.es');

// Components
const ShippingDetailsModal = require('./ShippingDetailsModal');
require('react-modal-wrapper/dist/main.css');

const {
    OPEN_DETAILS_FROM_SIDEBAR,
    OPEN_DETAILS_FROM_DESCRIPTION,
} = require('../../constants/shippingConstants');
const {
    REQUEST_SHIPPING_FLOW,
} = require('dibs-buyer-layout/src/authModal/authentication/authFlowConstants');
const userHelper = require('../../../global/core/commonjs/userHelper');

// Helpers
const provideContext = require('fluxible-addons-react/provideContext');
const connectToStores = require('fluxible-addons-react/connectToStores');
const { getValidQuote } = require('./shippingHelpers');
const { trackGaEvent } = require('../../helpers/pdpTracking');
const chatUtils = require('dibs-buyer-layout/src/utils/chat').default;

// Request Shipping Quote Modal
const { connect } = require('react-redux');
import RequestShippingQuoteModal from 'dibs-request-shipping-modal';

const onOpen = ({ output, source, customQuoteAvailable }) => {
    return () => {
        const labels = [`pdp ${source}`];
        labels.push(output ? 'shipping quote provided' : 'no shipping quote provided');
        if (customQuoteAvailable) {
            labels.push('custom quote request available');
        }
        trackGaEvent('product', 'view shipping details', labels.join('|'));
        chatUtils.track.shippingDetailsClick();
    };
};

const hasNoQuotes = ({ domestic, local, shipmentQuotes } = {}) => {
    return !domestic.length && !local.length && !shipmentQuotes.length;
};

class ShippingDetailsLink extends Component {
    constructor(props) {
        super(props);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.authModalShow = this.authModalShow.bind(this);
        this.getLoadToStep = this.getLoadToStep.bind(this);
        this.skipDetailsModal = this.skipDetailsModal.bind(this);
        this.onShowQuoteRequest = this.onShowQuoteRequest.bind(this);

        this.state = {
            isOpened:
                !!props.justAuthenticatedFromQuoteRequest &&
                props.parentName === props.quoteRequestInitiatedFrom,
            loadToStep: this.getLoadToStep(props)
        };
    }
    openModal() {
        this.setState({ isOpened: true });
        this.props.relay.forceFetch();
    }
    closeModal() {
        this.props.context.executeAction(PdpActions.setShippingRequestCompleted);
        this.setState({
            isOpened: false,
            loadToStep: 'initialStepOverride',
        });
    }
    getLoadToStep(props) {
        return this.skipDetailsModal(props || this.props) ? 'quoteRequest' : 'initialStepOverride'
    }
    authModalShow() {
        const options = {
            label: 'save item - product page',
        };

        return userHelper.checkLogin(options, REQUEST_SHIPPING_FLOW, false);
    }
    onShowQuoteRequest() {
        const { context, userId, parentName } = this.props;
        if (!userId) {
            this.setState({ isOpened: false });
            this.authModalShow().then(() => {
                context.executeAction(PdpActions.setShippingRequestAuthenticated, {
                    parentComponentName: parentName,
                });
            });
        }
    }

    skipDetailsModal(props) {
        const {viewer, user, hasUserId, quotes, justAuthenticatedFromQuoteRequest} = props || this.props;
        const quoteRequestForAllIsEnabled = get(viewer, 'quoteRequestForAllIsEnabled');
        const isVerifiedTrade = get(user, 'canSeeTradeReturns', false);
        const canRequest = hasUserId && (quoteRequestForAllIsEnabled || isVerifiedTrade);
        return justAuthenticatedFromQuoteRequest || (canRequest && hasNoQuotes(quotes));
    }

    render() {
        const {
            currency,
            quotes,
            user = {},
            link,
            source,
            itemId,
            hasUserId,
            userId,
            viewer = {},
            customQuoteAvailable,
            trackingLocation,
            item,
        } = this.props;

        const skipDetailsModal = this.skipDetailsModal();
        const nextStep = this.getLoadToStep();

        const { output } = getValidQuote({
            quotes: quotes.domestic,
            regionType: 'DOMESTIC',
            currency,
        });

        let detailsModal = skipDetailsModal ? null : (
            <ShippingDetailsModal
                quotes={quotes}
                currency={currency}
                user={user}
                source={source}
                itemId={itemId}
                hasUserId={hasUserId}
                userId={userId}
                closeShippingModal={this.closeModal}
                viewer={viewer}
                item={item}
            />
        );

        return (
            <div>
                <div className="pdp-shipping-details-link">
                    {React.cloneElement(link, { onClick: this.openModal })}
                </div>

                <RequestShippingQuoteModal
                    viewer={viewer}
                    isOpened={this.state.isOpened}
                    closeShippingModal={this.closeModal}
                    userId={userId}
                    user={null}
                    itemId={itemId}
                    loadToStep={nextStep}
                    trackingLocation={trackingLocation}
                    onShowQuoteRequest={this.onShowQuoteRequest}
                    onOpen={onOpen({ output, source, customQuoteAvailable })}
                >
                    {detailsModal}
                </RequestShippingQuoteModal>
            </div>
        );
    }
}

ShippingDetailsLink.propTypes = {
    context: PropTypes.object,
    customQuoteAvailable: PropTypes.bool,
    currency: PropTypes.string.isRequired,
    quotes: PropTypes.object.isRequired,
    user: PropTypes.object,
    itemId: PropTypes.string,
    parentName: PropTypes.string,
    hasUserId: PropTypes.bool,
    userId: PropTypes.string,
    dealerPk: PropTypes.string,
    viewer: PropTypes.object,
    link: PropTypes.element.isRequired,
    source: PropTypes.oneOf([OPEN_DETAILS_FROM_SIDEBAR, OPEN_DETAILS_FROM_DESCRIPTION]).isRequired,
    regionType: PropTypes.string.isRequired,
    dealerData: PropTypes.object,
    relay: PropTypes.object,
    trackingLocation: PropTypes.string,
    quoteRequestAuthStatus: PropTypes.string,
    onShippingRequestAuthCompleted: PropTypes.func,
    onShippingRequestFlowCompleted: PropTypes.func,
    justAuthenticatedFromQuoteRequest: PropTypes.bool,
    quoteRequestInitiatedFrom: PropTypes.string,
    openModalKey: PropTypes.string,
    pagePosition: PropTypes.string,
    currentStep: PropTypes.string,
    item: PropTypes.object,
};

// we need these props from the shipping quote request modal redux store (which is a parent of the
// NewPdpRoot Relay instance) in order to know if we were in the middle of the shipping request flow
// when the user was prompted to login, triggering a re-render of this component.
const connectToRedux = connect(({ isSubmitAfterAuth, openModalKey }) => ({
    isSubmitAfterAuth,
    openModalKey,
}));

module.exports = Relay.createContainer(
    connectToRedux(
        provideContext(
            connectToStores(ShippingDetailsLink, [ItemStore, UserStore, PdpUiStore], context => {
                const userStore = context.getStore(UserStore);
                const itemStore = context.getStore(ItemStore);
                const pdpUiStore = context.getStore(PdpUiStore);
                return {
                    justAuthenticatedFromQuoteRequest: pdpUiStore.isJustAuthenticatedFromQuoteRequest(),
                    quoteRequestInitiatedFrom: pdpUiStore.getQuoteRequestInitiatedFromName(),
                    currency: userStore.getCurrency(),
                    copy: itemStore.getCopy(),
                };
            })
        )
    ),
    {
        initialVariables: {
            hasUserId: false,
            shouldFetchTransaction: false,
            userId: null,
            itemId: null,
            itemIds: [],
            userIds: [],
        },
        prepareVariables: prevVariables => {
            const { itemId, userId } = prevVariables;
            const itemIds = itemId ? [itemId] : [];
            const userIds = userId ? [userId] : [];
            const shouldFetchTransaction = !!userIds.length;
            return Object.assign({}, prevVariables, { userIds, itemIds, shouldFetchTransaction });
        },
        fragments: {
            user: ({ hasUserId, itemId, userId }) => Relay.QL`
            fragment on User {
                canSeeTradeReturns: hasPermission(name: "B_TRADE_RETURN_POLICY")
                ${ShippingDetailsModal.getFragment('user', { hasUserId, itemId, userId })}
            }
        `,
            item: ({ hasUserId, itemId, userId }) => Relay.QL`
            fragment on Item {
                ${ShippingDetailsModal.getFragment('item', { hasUserId, itemId, userId })}
            }
        `,
            viewer: ({
                hasUserId,
                itemId,
                userId,
                itemIds,
                userIds,
                shouldFetchTransaction,
            }) => Relay.QL`
            fragment on Viewer {
                quoteRequestForAllIsEnabled: isEnabled(key: "enableRequestQuoteForAllLoggedIn")
                ${ShippingDetailsModal.getFragment('viewer', { hasUserId, itemId, userId })}
                ${RequestShippingQuoteModal.getFragment('viewer', {
                    hasUserId,
                    itemId,
                    userId,
                    itemIds,
                    userIds,
                    shouldFetchTransaction,
                    shouldFetchConversation: hasUserId,
                })}
           }
        `,
        },
    }
);



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/ShippingDetailsLink.jsx